import {
  Avatar,
  Box,
  Flex,
  HStack,
  Stack,
  Text,
  useColorModeValue,
  Collapse,
  Icon,
} from "@chakra-ui/react";
import { RiAlarmWarningLine } from "react-icons/ri";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useContext, useState } from "react";
import { UserProfileContext } from "../../context/userProfileContext";
import { NAV_ITEMS } from "./navItems";
import { v4 as id } from "uuid";
import CustomModal from "../CustomModal";
import NavEmergencyModal from "./NavEmergencyModal";
import { BsPersonXFill } from "react-icons/bs";
import { SecondaryButton } from "../CustomButton";
import { COLORS } from "../../constants/colors";
import { PROTECTED_PATHS } from "../../app/constants";
import { FaChevronDown } from "react-icons/fa";
import { FaChevronLeft } from "react-icons/fa";

const Sidebar = () => {
  const { userProfile } = useContext(UserProfileContext);
  const sidebarBg = useColorModeValue(COLORS.primary, COLORS.grey);
  const navigate = useNavigate();
  const location = useLocation();
  const [openSubMenus, setOpenSubMenus] = useState({});

  const handleLogout = () => {
    localStorage.removeItem("11p221#");
    window.location.replace("/login");
  };

  const toggleSubMenu = (index) => {
    setOpenSubMenus(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const handleNavItemClick = (navItem) => {
    if (navItem.externalLink) {
      navigate(PROTECTED_PATHS.CHAT, {
        state: { externalLink: navItem.externalLink },
      });
    } else if (navItem.to) {
      navigate(navItem.to);
    }
  };

  return (
    <Stack
      width="80%"
      bg={sidebarBg}
      opacity="90%"
      minH="100%"
      borderBottomRightRadius="5px"
      color={COLORS.white}
      pt="10"
      pl="10%"
    >
      <Box>
        <Avatar
          size="lg"
          name={userProfile?.tenantName}
          src={userProfile?.profilePicture}
        />
      </Box>
      <Text fontWeight="500" fontSize={"1rem"} pt="10px">
        {userProfile?.tenantName}
      </Text>
      <Text fontWeight="500" fontSize={".8rem"}>
        {userProfile?.email}
      </Text>
      
      <Stack spacing="5" pt="1.5rem">
        {NAV_ITEMS.map((navItem, index) => (
          <Box key={id()}>
            <HStack
              w="100%"
              cursor="pointer"
              onClick={() => {
                if (navItem.children) {
                  toggleSubMenu(index);
                } else {
                  handleNavItemClick(navItem);
                }
              }}
              bg={location.pathname === navItem.to ? "rgba(255, 255, 255, 0.1)" : "transparent"}
              p="2"
              borderRadius="md"
            >
              {navItem.icon}
              <Text fontSize="15px" pl="10px" flex="1">
                {navItem.title}
              </Text>
              {navItem.children && (
                <Icon
                  as={openSubMenus[index] ? FaChevronDown : FaChevronLeft}
                  transition="all .25s ease-in-out"
                  w={4}
                  h={4}
                />
              )}
            </HStack>
            
            {navItem.children && (
              <Collapse in={openSubMenus[index]} animateOpacity>
                <Stack pl="8" mt="2" spacing="2">
                  {navItem.children.map(child => (
                    <HStack
                      key={id()}
                      cursor="pointer"
                      onClick={() => handleNavItemClick(child)}
                      bg={location.pathname === child.to ? "rgba(255, 255, 255, 0.1)" : "transparent"}
                      p="2"
                      borderRadius="md"
                    >
                      {child.icon}
                      <Text fontSize="14px" pl="10px">
                        {child.title}
                      </Text>
                    </HStack>
                  ))}
                </Stack>
              </Collapse>
            )}
          </Box>
        ))}

        <Flex justify="flex-start" py="6vh">
          <SecondaryButton
            size="sm"
            shadow="md"
            opacity="80%"
            bg="primaryDark"
            _hover={{ backgroundColor: "primaryDark" }}
            w="150px"
            leftIcon={<BsPersonXFill />}
            btnText="Logout"
            onClick={handleLogout}
          />
        </Flex>
      </Stack>
    </Stack>
  );
};

export default Sidebar;